// The group endpoint selects by user_group_id. Branch selection does not
// change its response. User/company keep cached grants inside their tenant.
export function permissionContext(profile) {
  if (!profile || typeof profile._id !== 'string' || !profile._id.trim()) return '';
  return JSON.stringify([profile._id, profile.company_group || '']);
}

export function permissionIdentity(profile) {
  const group = profile && profile.permission && profile.permission.user_group;
  if (!profile || typeof profile._id !== 'string' || !profile._id.trim() ||
      typeof group !== 'string' || !group.trim()) return '';
  return JSON.stringify([profile._id, group, profile.company_group || '']);
}

function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function validPermissionResponse(response, groupId) {
  const result = response && response.result;
  return Boolean(response && response.status === 'success' && isObject(result) &&
    (!Object.prototype.hasOwnProperty.call(result, '_id') || result._id === groupId) &&
    (result.tag === undefined || typeof result.tag === 'string') &&
    isObject(result.permission) &&
    Object.values(result.permission).every(value => value === 0 || value === 1 || value === 2));
}

export function clearPermissions(state) {
  state.group_permissions = {};
  state.group_tag = '';
  state.permission_identity = '';
  state.permissions_ready = false;
  state.permissions_loading = false;
  state.permissions_error = null;
}
